import { render, staticRenderFns } from "./ReportMetadataTable.vue?vue&type=template&id=1a3a4f58&"
import script from "./ReportMetadataTable.vue?vue&type=script&lang=ts&"
export * from "./ReportMetadataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports